import { ChangeEvent, useEffect } from "react";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  loginUser,
  setPassword,
  setUserName,
} from "src/redux/slices/bMCProfileSlice";
import "./Login.scss";
import { isNullOrWhiteSpace } from "src/utils/helpers";
import { useTranslation } from "react-i18next";
import { RoutePaths } from "src/resources/enum";
const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const bMCProfile = useSelector((state: any) => state.bMCProfile);
  const { t } = useTranslation(["common", "user"]);
  const onSuccess = (responseData: any) => {
    if (!responseData?.FirstLogin) {
      navigate(RoutePaths.ChangePassword);
    } else {
      navigate(RoutePaths.Dashboard);
    }
  };
  const handleLogin = (e: any) => {
    e.preventDefault();
    dispatch(loginUser(onSuccess) as any);
  };
  const handleUsername = (e: ChangeEvent<HTMLInputElement>): void => {
    dispatch(setUserName(e.target.value));
  };

  const handlePassword = (e: ChangeEvent<HTMLInputElement>): void => {
    dispatch(setPassword(e.target.value));
  };
  useEffect(() => {
    return () => {
      // reset the data when component is unmounted
      dispatch(setUserName(""));
      dispatch(setPassword(""));
    };
  }, []);
  return (
    <div className="d-flex justify-content-center align-items-center login">
      <Card className="login-card">
        <form
          className="d-flex flex-column justify-content-center"
          onSubmit={handleLogin}
        >
          <div className="form-control">
            <label htmlFor="username">{t("userName")}</label>
            <InputText
              id="username"
              name="username"
              placeholder={t("userNameLabel")}
              className="w-100"
              autoComplete="false"
              onChange={handleUsername}
            />
          </div>
          <div className="form-control">
            <label htmlFor="password">{t("password")}</label>
            <InputText
              id="password"
              name="password"
              type="password"
              placeholder={t("passwordLabel")}
              className="w-100"
              autoComplete="false"
              onChange={handlePassword}
            />
          </div>
          <Button
            type="submit"
            label={t("login")}
            className="primary-btn border-radius-100"
            disabled={
              isNullOrWhiteSpace(bMCProfile.userName) ||
              isNullOrWhiteSpace(bMCProfile.password)
            }
          />
        </form>
        <div className="d-flex justify-content-around fit-content gap-5">
          {/* <Link to="/reset-password" className="text-decoration-none">
            {t("register")}
          </Link> */}
          <Link
            to="/forget-password"
            className="text-decoration-none font-size-medium"
          >
            {t("forgotPassword")}{" "}
          </Link>
        </div>
      </Card>
    </div>
  );
};

export default Login;
